export default __webpack_public_path__ + "static/media/partner-ship.b6d0e23c.png";